import Service from "../../service";

const DriverConfigBonus = {
    getBonus() {
        return Service.get("/configBonus");
    },
    showBonus(id) {
        return Service.get("/configBonus/" + id);
    },
    updateBonus(id, data) {
        return Service.put("/configBonus/" + id, data);
    },
    createBonus(data) {
        return Service.post("/configBonus", data);
    },
    deleteBonus(id) {
        return Service.delete("/configBonus/" + id);
    },
    getProvince() {
        return Service.get("/configProvince");
    },
    showProvince(id) {
        return Service.get("/configProvince/" + id);
    },
    updateProvince(id, data) {
        return Service.put("/configProvince/" + id, data);
    },
    createProvince(data) {
        return Service.post("/configProvince", data);
    },
    deleteProvince(id) {
        return Service.delete("/configProvince/" + id);
    },
};
export default DriverConfigBonus;
